import React from "react";
import { Modal, Button, Typography } from "antd";
import { SafetyOutlined, CheckCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

export interface ConsentModalProps {
  open: boolean;
  onAccept: () => void;
  onDecline: () => void;
  loading?: boolean;
}

export default function ConsentModal({
  open,
  onAccept,
  onDecline,
  loading = false,
}: ConsentModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onDecline}
      footer={null}
      closable={!loading}
      maskClosable={!loading}
      width={480}
      centered
      aria-labelledby="consent-modal-title"
      aria-describedby="consent-modal-description"
    >
      <div className="text-center pb-4">
        <div
          className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-blue-50 mb-4"
          aria-hidden
        >
          <SafetyOutlined className="text-2xl text-blue-600" />
        </div>
        <Typography.Title level={4} id="consent-modal-title" className="!mb-2">
          Privacy consent required
        </Typography.Title>
        <Text id="consent-modal-description" className="text-gray-600 block text-left mb-4">
          To use Kobikuul AI chat, we need your consent to process your health information and
          chat data securely.
        </Text>
        <ul className="text-left text-sm text-gray-600 space-y-2 mb-4 list-none pl-0">
          <li className="flex items-start gap-2">
            <CheckCircleOutlined className="text-green-500 mt-0.5 shrink-0" />
            <span>Provide personalized health advice and recommendations</span>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircleOutlined className="text-green-500 mt-0.5 shrink-0" />
            <span>Process prescription images for medication information</span>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircleOutlined className="text-green-500 mt-0.5 shrink-0" />
            <span>Maintain encrypted conversation history</span>
          </li>
          <li className="flex items-start gap-2">
            <CheckCircleOutlined className="text-green-500 mt-0.5 shrink-0" />
            <span>You can revoke consent at any time</span>
          </li>
        </ul>
        <Text type="secondary" className="block text-left text-xs italic mb-4">
          Your data is protected under Ghana's Data Protection Act (Act 843). By
          accepting, you agree to our privacy policy and terms of service.
        </Text>
        <div className="flex gap-3 justify-end">
          <Button onClick={onDecline} disabled={loading}>
            Decline
          </Button>
          <Button type="primary" onClick={onAccept} loading={loading}>
            Accept
          </Button>
        </div>
      </div>
    </Modal>
  );
}
